var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"asset-buttton primary",attrs:{"type":"button"},on:{"click":_vm.viewAsset}},[_vm._v("\n         "+_vm._s(_vm.$t('text.clickButtons.viewAsset'))+"\n     ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }